<template>
    <div style="position: relative; overflow: hidden">

        <div
            style="position: absolute; width: fit-content; height: fit-content; left: 0; bottom: 10%; z-index: 1; padding: 10px; border: 1px solid gray; border-left: 0; border-radius: 0 8px 8px 0; overflow: hidden; transition: all 1s ease;"
            :style="{'transform': showLegends ? 'translateX(calc(-100% + 40px))' : '', 'background' : showLegends ? '#f6f6f6' : 'white'}"
        >
            <div style="display: flex; flex-direction: row; align-items: center;">
                <table>
                    <tbody>
                        <tr v-for="legend in legendsData">
                            <th><div style="width: 20px; height: 20px; border-radius: 4px; border:1px solid grey" :style="{'background' : baseColor + legend.colorPostfix}"></div></th>
                            <td style="padding: 5px 0 5px 20px; font-weight: bold;">{{ legend.title }}</td>
                        </tr>
                    </tbody>
                </table>
                <div style="height: 100%; position: relative; padding: 20px 10px 20px 20px; cursor: pointer;" @click="showLegends = !showLegends">
                    <i
                        class="fas fa-chevron-left"
                        :style="{'transform' : showLegends ? 'rotate(180deg)' : ''}"
                        style="transition: all .3s ease"
                    ></i>
                </div>
            </div>
        </div>

        <l-map
            v-if="indonesiaJson"
            :center="center"
            :zoom="4"
            ref="map"
            style="min-height:450px;width:100%;z-index:0;position:relative; background:#E3F1F2"
            :zoom-control="false" :options="{ scrollWheelZoom: false , doubleClickZoom : false }"
            >

            <l-geo-json
                :geojson="indonesiaJson"
                :options="options"
                :optionsStyle="styleOptions"
            ></l-geo-json>
        </l-map>

        <!-- <GmapMap
            :center="centerGmap"
            :zoom="zoom"
            map-type-id="terrain"
            style="width: 100%; min-height: 500px"
        >

                <gmap-marker v-for="(m, index) in markers"
                    :position="m.lat ? m: {lat: 0.00000 , lng: 0.0000}"
                    :clickable="true" :draggable="true"
                    :key="index"
                    @click="centerGmap=m.position;zoom=15"
                ></gmap-marker>

        </GmapMap> -->
    </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LGeoJson, LIcon, LPopup, LTooltip, LCircle } from "vue2-leaflet";
import indonesiaJson from '@/assets/adm_1.json'
import "leaflet/dist/leaflet.css"
import GmapCluster from 'vue2-google-maps/src/components/cluster' // replace src with dist if you have Babel issues
export default {
    components : {
        LMap,
        LGeoJson,
        LTileLayer,
        GmapCluster
    },
    props : ['activityData' , 'invokeCenter' , 'data'],
    mounted () {
        // console.log(this.$options.indonesiaJson)
        // console.log(this.activityData)
        // this.loadMapData ()
        // this.markers = this.activityData.map(function(x) {
        //     return {
        //         lat : x.lat,
        //         lng : x.lng
        //     }
        // })

        this.loadMapData()
        // console.log(this.markers)
    },
    watch : {
        data : function (){
            this.loadMapData()
        },
        invokeCenter : function () {
            console.log(this.invokeCenter)
            this.centerGmap = {
                lat : this.invokeCenter.lat,
                lng : this.invokeCenter.lng
            }
            this.zoom = 5;
        }
    },
    
    computed : {
        options() {
            return {
                onEachFeature: this.onEachFeatureFunction,
            };
        },
    },
    data () {
        return {
            zoom : 5,
            markers : [],
            center : [-2.957026, 117.761289],
            centerGmap : {lat : -2.757026 , lng : 116.761289},
            indonesiaJson : null,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

            showLegends: true,
            baseColor : '#E3242B',
            legendsData : [
                {title: '> 80% Genuine', colorPostfix: 'FF'},
                {title: '60 - 80% Genuine', colorPostfix: 'CC'},
                {title: '40 - 60% Genuine', colorPostfix: '99'},
                {title: '20 - 40% Genuine', colorPostfix: '66'},
                {title: '5 - 20% Genuine', colorPostfix: '33'},
                {title: '< 5% Genuine', colorPostfix: '00'},
            ]
        }
    },
    indonesiaJson : null,
    methods : {
        onEachFeatureFunction() {
            return (feature, layer) => {
                layer.bindTooltip(
                    `${feature.properties}`
                ,
                { permanent: false, sticky: true }
                );
                
            };
            
        },
        styleOptions(feature) {
            return {
                fillColor: '#E3242B',
                weight: 2,
                opacity: 1,
                color: '#333',
                fillOpacity: feature.properties.opacity ? feature.properties.opacity : 0 // Replace 'intensity' with your actual property
            };
        },
        async loadMapData () {
            // try {
            //     let resp = await this.$http.get('/api/highlight/map?level=provinsi')

            //     console.log(indonesiaJson)

            //     // console.log(resp.data.data)
            //     let data = resp.data.data

            //     const sum = data.reduce((total, item) => total + parseInt(item.distribution), 0);

            //     // indonesiaJson.features.map(x => x.properties.opacity)

            //     for(var i in data) {
            //         let curData = data[i]
            //         let index = indonesiaJson.features.findIndex(x => x.properties.ADM1_PCODE == curData.kode_provinsi)

            //         indonesiaJson.features[index].properties.opacity = parseInt(curData.distribution) / sum
            //     }

            //     this.indonesiaJson = indonesiaJson

            // }
            // catch(err) {
            //     console.log(err)
            // }
            this.indonesiaJson = null
            let mapData = JSON.parse(JSON.stringify(indonesiaJson))

            
            

            for(var i in this.data) {
                let curData = this.data[i]
                if(!curData) continue
                let index = indonesiaJson.features.findIndex(x => x.properties.ADM1_PCODE == curData.kode_provinsi)

                mapData.features[index].properties.opacity = curData.percentage / 100 * 2.2
                // console.log(mapData.features[i].properties.opacity)
            }

            this.indonesiaJson = mapData


            
        }
    }
}
</script>

<style>
    .leaflet-container{
        background-color: #FFF;
    }
</style>